import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import usePageTracking from "../../../hooks/usePageTracking";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";
import { useNavigate, useParams } from "react-router-dom";
import { Spinner, Button, Card } from "react-bootstrap";
import "./productDetail.scss";
import {
  addToCart,
  fetchProductById,
  fetchProducts,
} from "../../../redux/slices/shopSlice";
import { FiArrowLeft } from "react-icons/fi";
import { sessionId } from "../../../redux/slices/cityComparisonSlice";
import {
  addInCart,
  productView,
} from "../../../redux/slices/shopTrackingSlice";

const ProductDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  // Track Activity
  usePageTracking("PRODUCT_DETAIL");
  useEffect(() => {
    dispatch(activityStart({ page_name: "PRODUCT_DETAIL", platform: "web" }));
    return () => dispatch(activityEnd({ page_name: "PRODUCT_DETAIL" }));
  }, [dispatch]);
  const navigate = useNavigate();

  const { selectedProduct, loading, products } = useSelector(
    (state) => state.shop,
  );

  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    dispatch(fetchProductById(id));
    dispatch(fetchProducts());
  }, [id, dispatch]);
  const relatedProducts =
    products?.filter((p) => selectedProduct?.related_ids?.includes(p.id)) || [];
  useEffect(() => {
    if (selectedProduct?.images?.length) {
      setActiveImage(selectedProduct.images[0].src);
    }
  }, [selectedProduct]);

  const user = useSelector((state) => state.auth?.user);

  useEffect(() => {
    if (!user) {
      sessionStorage.removeItem("comparison_session_id");
      sessionStorage.removeItem("session_expiry");

      console.log("🧹 Session cleared on logout");
    }
  }, [user]);
  useEffect(() => {
    if (!user?.id) return;

    const existingSession = sessionStorage.getItem("comparison_session_id");
    const expiry = sessionStorage.getItem("session_expiry");

    if (existingSession && expiry && Date.now() < Number(expiry)) {
      
      return;
    }
    dispatch(sessionId()).then((res) => {
      const data = res.payload?.data;

      if (data?.session_id) {
        sessionStorage.setItem("comparison_session_id", data.session_id);

        const expiryTime = Date.now() + data.expires_in * 1000;
        sessionStorage.setItem("session_expiry", expiryTime);

        
      }
    });
  }, [user]);

  // useEffect(() => {
  //   const sessionId = sessionStorage.getItem("comparison_session_id");

  //   const payload = {
  //     user_id: user?.id || null,
  //     course_name: selectedProduct?.name,
  //     session_id: sessionId,
  //     platform: "web",
  //   };

  //   if (sessionId) {
  //     dispatch(productView(payload));
  //   }
  // }, [user, dispatch, selectedProduct?.name]);
  useEffect(() => {
    const sessionId = sessionStorage.getItem("comparison_session_id");

    if (!selectedProduct || !sessionId) return;

    // prevent using old redux product
    if (selectedProduct.id !== Number(id)) return;

    const payload = {
      user_id: user?.id || null,
      course_name: selectedProduct.name,
      session_id: sessionId,
      platform: "web",
    };

    dispatch(productView(payload));
  }, [selectedProduct, id, user, dispatch]);

  if (loading) {
    return (
      <div className="loader-wrapper">
        <Spinner animation="border" />
        <span className="ms-2">Loading product...</span>
      </div>
    );
  }

  if (!selectedProduct) return null;

  return (
    <div className="product-detail-wrapper">
      <div className="app-page-title">
        <div className="page-title-heading d-flex align-items-center">
          <FiArrowLeft
            size={40}
            className="icon cursor-pointer"
            onClick={() => navigate("/shop/products")}
          />
          <h3 className="page-title">{selectedProduct?.name}</h3>
        </div>
      </div>

      <Card className="product-detail-card">
        <Card.Body>
          {/* IMAGE GALLERY */}
          <div className="product-gallery">
            {/* MAIN IMAGE */}
            <div className="main-image">
              <img src={activeImage} alt={selectedProduct?.name} />
            </div>

            {/* THUMBNAILS */}
            {selectedProduct?.images?.length > 1 && (
              <div className="thumbnail-list">
                {selectedProduct.images.map((img) => (
                  <img
                    key={img.id}
                    src={img.src}
                    alt=""
                    className={activeImage === img.src ? "active" : ""}
                    onClick={() => setActiveImage(img.src)}
                  />
                ))}
              </div>
            )}
          </div>

          <div className="product-info">
            <h4>{selectedProduct?.name}</h4>

            <div className="price">
              {selectedProduct?.regular_price && (
                <span className="old-price">
                  ${selectedProduct.regular_price}
                </span>
              )}
              <span className="new-price">${selectedProduct?.price}</span>
            </div>

            {/* <Button
              className="add-cart-btn"
              onClick={(e) => {
                e.stopPropagation();
                dispatch(addToCart(selectedProduct));
                navigate("/shop/cart");
              }}
            >
              Add to cart
            </Button> */}
            <div className="buttons">
              <Button
                className="btn btn-primary"
                onClick={(e) => {
                  e.stopPropagation();

                  const sessionId = sessionStorage.getItem(
                    "comparison_session_id",
                  );

                  const payload = {
                    event_type: "add_to_cart",
                    user_id: user?.id || null,
                    session_id: sessionId,
                    course_name: selectedProduct?.name,
                    platform: "web",
                  };

                  if (sessionId) {
                    dispatch(addInCart(payload));
                  }

                  dispatch(addToCart(selectedProduct));
                  navigate("/shop/cart");
                }}
              >
                Add to cart
              </Button>
            </div>

            <div
              className="descriptions"
              dangerouslySetInnerHTML={{
                __html: selectedProduct?.description,
              }}
            />
          </div>
        </Card.Body>
      </Card>
      {relatedProducts.length > 0 && (
        <Card>
          <Card.Body>
            <div className="related-products">
              <h4>Related Products</h4>

              <div className="products-grid g-3 row">
                {relatedProducts.map((product) => (
                  <Card
                    key={product.id}
                    className="product-card col-sm-6 col-xl-4"
                    onClick={() =>
                      navigate(`/shop/products-detail/${product.id}`)
                    }
                  >
                    <div className="content-wrap">
                      <div className="product-banner">
                        <img
                          src={product.images?.[0]?.src}
                          alt={product.name}
                        />
                      </div>

                      <div className="product-body">
                        <div className="product-dec">{product.name}</div>

                        <div className="price">
                          {product.regular_price && (
                            <span className="old-price">
                              ${product.regular_price}
                            </span>
                          )}

                          <span className="new-price">${product.price}</span>
                        </div>
                        <div className="buttons">
                          <Button
                            className="btn btn-primary add-cart"
                            onClick={(e) => {
                              e.stopPropagation();

                              const sessionId = sessionStorage.getItem(
                                "comparison_session_id",
                              );

                              const payload = {
                                event_type: "add_to_cart",
                                user_id: user?.id || null,
                                session_id: sessionId,
                                course_name: selectedProduct?.name,
                                platform: "web",
                              };

                              if (sessionId) {
                                dispatch(addInCart(payload));
                              }

                              dispatch(addToCart(selectedProduct));
                              navigate("/shop/cart");
                            }}
                          >
                            Add to cart
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default ProductDetail;
